export const ClassType = {
    WeClass: 'weclass',
    Student: 'student',
} as const;

export const ReportTab = {
    Answer: 'answer',
    AiTotal: 'ai-total',
} as const;
